const billings = () => {
    return (
        <div className="overflow-x-auto bg-white rounded-2xl w-auto md:w-auto lg:w-auto shadow-lg p-2 h-[86vh] m-2 flex flex-col gap-3">Coming soon</div>
    )
}

export default billings;